import React, { useState, useEffect } from 'react'
import { Breadcrumb as AntdBreadcrumb } from 'antd'
import { useLocation, Link } from 'react-router-dom'
import exams from 'assets/data/exams'

const clientType = localStorage.getItem('clientType')

const getNameView = location => {
  let name
  if (location.includes('/accounts')) name = 'Usuários'
  if (location.includes('/organizations')) name = 'Organizações'
  if (location.includes('/clients')) name = 'Clientes'
  if (location.includes('/clinics')) name = 'Clínicas'
  if (location.includes('/patients')) name = 'Pacientes'
  if (location.includes('/anamnesis')) name = 'Anamneses'
  if (location.includes('/exams')) name = 'Serviços'
  if (location.includes('/campaigns')) name = 'Campanhas'
  if (location.includes('/statistics')) name = 'Estatísticas'
  if (location.includes('/pending-reports'))
    name = clientType === 'TELEMEDICINE_CENTER' ? 'Laudos' : 'Laudos Pendentes'
  if (location.includes('/in-progress-exams')) name = 'Exames em andamento'
  if (location.includes('/listing-reports')) name = 'Lista de exames'
  if (location.includes('/general-reports')) name = 'Relatórios Gerais'
  if (location.includes('/device-calibration')) name = 'Controle de Qualidade'
  if (location.includes('/normality-limits')) name = 'Limite da Normalidade'
  return name
}

const Breadcrumb = () => {
  const location = useLocation()

  const screenWidth = window.screen.width;

  const [label, setLabel] = useState('')
  // let label = ''

  const renderChildItem =
    location?.pathname?.includes('/new') ||
    location?.pathname?.includes('/edit') ||
    location?.pathname?.includes('/view')
  const categoryUrl = () => {
    if (location?.pathname?.includes('new')) {
      return location?.pathname?.replace('/new', '')
    }
    if (location?.pathname?.includes('view')) {
      const value = location?.pathname?.replace('/view', '')
      const arrayValues = value.split('/')
      return `/${arrayValues[1]}`
    }
    if (location?.pathname?.includes('edit')) {
      const value = location?.pathname?.replace('/edit', '')
      const arrayValues = value.split('/')
      return `/${arrayValues[1]}`
    }

    if (location?.pathname?.includes('exams')) {
      const value = location?.pathname?.replace('')
      const arrayValues = value.split('/')
      return `/${arrayValues[1]}`
    }

    return location?.pathname
  }

  useEffect(() => {
    let auxLabel = ''
    const innerlabel = location?.pathname?.replace('/', '')
    const arrLabel = innerlabel.split('/')

    const currentExam = exams.find(exam => {
      return exam.routeTo === arrLabel[1]
    })

    if (currentExam) auxLabel = currentExam.name

    if (arrLabel[1] && arrLabel[1].includes('abpm'))
      auxLabel = 'MAPA - Monitorização Ambulatorial da Pressão Arterial'
    if (arrLabel[1] && arrLabel[1].includes('hbpm'))
      auxLabel = 'MRPA - Monitorização Residencial da Pressão Arterial'

    setLabel(auxLabel)
    // eslint-disable-next-line
  }, [])

  return (
    <AntdBreadcrumb separator={<span style={{ color: 'white' }}> {'>'} </span>}>
      <AntdBreadcrumb.Item>
        <Link to="/" style={{ color: 'white' }}>
          Home
        </Link>
      </AntdBreadcrumb.Item>
      <AntdBreadcrumb.Item>
        <Link to={categoryUrl()}>
          <span style={{ color: 'white' }}>
            {getNameView(location?.pathname)}
          </span>
        </Link>
      </AntdBreadcrumb.Item>
      {renderChildItem && (
        <AntdBreadcrumb.Item>
          <span style={{ color: 'white' }}>
            {location?.pathname?.includes('/new')
              ? 'Cadastrar'
              : location?.pathname?.includes('/view')
                ? 'Visualizar'
                : 'Editar'}
          </span>
        </AntdBreadcrumb.Item>
      )}

      {label !== '' && (
        <AntdBreadcrumb.Item>
          <span style={{
            color: 'white',
            display: `${screenWidth <= 768 ? 'inline-block' : ''}`,
            whiteSpace: `${screenWidth <= 768 ? 'nowrap' : ''}`,
            overflow: `${screenWidth <= 768 ? 'hidden' : ''}`,
            textOverflow: `${screenWidth <= 768 ? 'ellipsis' : ''}`,
            width: `${screenWidth <= 768 ? '40vw' : ''}`
            }}>{label}</span>
        </AntdBreadcrumb.Item>
      )}
    </AntdBreadcrumb>
  )
}

export default Breadcrumb
